// marker.directive.ts
import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[appMarker]'
})
export class MarkerDirective implements OnInit {
  @Input() x: number = 0;
  @Input() y: number = 0;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setStyle(this.el.nativeElement, 'left', `${this.x * 100}%`);
    this.renderer.setStyle(this.el.nativeElement, 'top', `${this.y * 100}%`);
  }
}
